import { useSelector } from "react-redux";
import usePropHelper from "../../../hooks/PropHelper";
import Interaction from "../../../models/interactions/Interaction";
import { selectUsedProps } from "../../../app/slices/PropLibrarySlice";
import { useMemo } from "react";
import { ISetPropState } from "../../../models/interactions/SetPropState";
import AllPropsDropdown from "../../previews/show_ui_prop/AllPropsDropdown";
import PiInteractionStringDropdown from "../../../components/PiInteractionStringDropdown";
import PiCreatorDropdownItem from "../../../components/PiCreatorDropdown/PiCreatorDropdownItem";
import {
  selectAllPropPresets,
  selectSelectedElement,
} from "../../../app/slices/TrainingSlice";
import NodeAllPropsDropdown from "../components/NodeAllPropsDropdown";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";
import NodeStringDropdown from "../components/NodeStringDropdown";
export default function SetPropStateNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const propInteraction = props.interaction as ISetPropState;
  const { getUsedPropByInstanceId } = usePropHelper();
  const usedProps = useSelector(selectUsedProps);
  const allPropPresets = useSelector(selectAllPropPresets);
  const { updateInteraction } = useUpdateSequenceInteraction();
  const selectedInteraction = useSelector(selectSelectedElement);
  const usedProp = useMemo(() => {
    if (!propInteraction.propId) return null;
    return getUsedPropByInstanceId(propInteraction.propId);
  }, [propInteraction.propId, usedProps]);

  const propDropdown = useMemo(
    () => (
      <NodeAllPropsDropdown
        label="Prop"
        selectedPropStateId={propInteraction.propId}
        onClick={(propStateId) => {
          updateInteraction(props.nodeId, {
            ...propInteraction,
            propId: propStateId,
            propState:
              propStateId != propInteraction.propId
                ? ""
                : propInteraction.propState,
          } as ISetPropState);
        }}
      />
    ),
    [propInteraction.propId, updateInteraction, props.nodeId]
  );

  const propStateDropdown = useMemo(
    () => (
      <NodeStringDropdown
        items={usedProp?.metadata.prop_states.map((p) => p.name) ?? []}
        selectedItem={propInteraction.propState}
        label="Prop State"
        onClick={(propState) => {
          updateInteraction(props.nodeId, {
            ...propInteraction,
            propState: propState,
          } as ISetPropState);
        }}
      />
    ),
    [usedProp, propInteraction.propState, updateInteraction, props.nodeId]
  );

  return (
    <div className="flex flex-col w-full h-full gap-[12px] noDrag">
      {propDropdown}
      {propStateDropdown}
    </div>
  );
}
